



















































































import { WidgetState } from '@/store/widget/types';
import { Component, Prop, Vue } from 'vue-property-decorator';
import { State } from 'vuex-class';

@Component
export default class PeopleInput extends Vue {
  @Prop() value!: { adults: number; children: number[] };
  @State('widget') widget!: WidgetState;

  onValue(event: any) {
    this.$emit('input', event.target.value);
  }

  get childrenAllowed() {
    return this.widget?.settings?.childrenNotAllowed ? false : true;
  }

  setAdults(value: string) {
    let newValue = parseInt(value);
    if (newValue > 9) newValue = 9;
    if (newValue < 1 || isNaN(newValue)) newValue = 1;

    this.$emit('input', Object.assign({}, this.value, { adults: newValue }));
    this.$forceUpdate();
  }

  setChildren(value: string) {
    let newValue = parseInt(value);
    if (newValue > 9) newValue = 9;
    if (newValue < 0 || isNaN(newValue)) newValue = 0;
    const children: any[] = [...this.value.children];
    const diff = newValue - this.value.children.length;

    if (newValue > this.value.children.length) {
      children.push(...Array(diff).fill(0));
    } else {
      children.splice(diff, this.value.children.length);
    }

    this.$emit('input', Object.assign({}, this.value, { children: children }));
    this.$forceUpdate();
  }

  setChildAge(value: string, childIndex: number) {
    let newValue = parseInt(value);
    if (newValue < 0 || isNaN(newValue)) newValue = 0;
    const children = [...this.value.children];
    children[childIndex] = newValue;

    this.$emit('input', Object.assign({}, this.value, { children: children }));
  }
}
